
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import DashboardLayout from './layout/DashboardLayout';
import Packages from './pages/packages/Packages';
import PackagesTable from './pages/packages/PackagesTable';
import Clients from './pages/clients/Clients';
import Leads from './pages/leads/Leads';
import LeadDetail from './pages/leads/LeadDetail';
import CallDashboard from './pages/calls/CallDashboard';
import NewFollowup from './pages/calls/NewFollowup';
import FollowupList from './pages/calls/FollowupList';
import CallCalendar from './pages/calls/CallCalendar';
import CallReports from './pages/calls/CallReports';
import Calendar from './pages/calendar/Calendar';
import Dashboard from './pages/dashboard/Dashboard';
import Documents from './pages/documents/Documents';
import Settings from './pages/settings/Settings';
import UsersAndRoles from './pages/users/Users';
import RequirePerm from './auth/RequirePerm';
import Quotations from './pages/quotation/Quotations';
import QuotationDetails from './pages/quotation/QuotationDetails';
import QuotationTables from './pages/quotation/QuotationTables';
import Login from './pages/Login';

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

const App = () => {
  return (
    <ConfigProvider>
      <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          {/* By default, show Packages */}
          <Route index element={<Navigate to="/quotations" replace />} />
          <Route path="packages" element={<Packages />} />
          <Route path="components" element={<PackagesTable />} />
          <Route path="clients" element={<RequirePerm perm="view_clients"><Clients /></RequirePerm>} />
          <Route path="leads" element={<RequirePerm perm="view_leads"><Leads /></RequirePerm>} />
          <Route path="leads/:id" element={<RequirePerm perm="view_leads"><LeadDetail /></RequirePerm>} />
          {/* Call & Follow-up Management (standalone module) */}
          <Route path="calls" element={<RequirePerm perm="view_calls"><CallDashboard /></RequirePerm>} />
          <Route path="calls/new" element={<RequirePerm perm="manage_calls"><NewFollowup /></RequirePerm>} />
          <Route path="calls/today" element={<RequirePerm perm="view_calls"><FollowupList view="today" /></RequirePerm>} />
          <Route path="calls/upcoming" element={<RequirePerm perm="view_calls"><FollowupList view="upcoming" /></RequirePerm>} />
          <Route path="calls/overdue" element={<RequirePerm perm="view_calls"><FollowupList view="overdue" /></RequirePerm>} />
          <Route path="calls/completed" element={<RequirePerm perm="view_calls"><FollowupList view="completed" /></RequirePerm>} />
          <Route path="calls/missed" element={<RequirePerm perm="view_calls"><FollowupList view="missed" /></RequirePerm>} />
          <Route path="calls/history" element={<RequirePerm perm="view_calls"><FollowupList view="history" /></RequirePerm>} />
          <Route path="calls/calendar" element={<RequirePerm perm="view_calendar"><CallCalendar /></RequirePerm>} />
          <Route path="calls/reports" element={<RequirePerm perm="view_calls"><CallReports /></RequirePerm>} />
          {/* Standalone Calendar (central scheduling hub) */}
          <Route path="calendar" element={<RequirePerm perm="view_calendar"><Calendar /></RequirePerm>} />
          {/* Dashboard, Documents, Settings, Users */}
          <Route path="dashboard" element={<RequirePerm perm="view_dashboard"><Dashboard /></RequirePerm>} />
          <Route path="documents" element={<RequirePerm perm="view_documents"><Documents /></RequirePerm>} />
          <Route path="settings" element={<RequirePerm perm="manage_settings"><Settings /></RequirePerm>} />
          <Route path="users" element={<RequirePerm perm="manage_users"><UsersAndRoles /></RequirePerm>} />
          <Route path="quotations" element={<Quotations />} />
          <Route path="quotation-details" element={<QuotationDetails />} />
          <Route path="quotation-view" element={<QuotationTables />} />
        </Route>
      </Routes>
    </Router>
    </ConfigProvider>
  );
};

export default App;
